export const DELETE_ATTACHED_FILE = 'DELETE_ATTACHED_FILE';
export const GET_APPLICATION_FILES_CONFIG = 'GET_APPLICATION_FILES_CONFIG';
